function initContact(contact_type) {

  function changeParentiFrameHeight(ele_parent) {

    let h = window.document.body.scrollHeight + 10;

    // 値が取れなかった場合の最低限の高さを保持しておく
    if (h <= 500) {
      h = 500;
    }

    ele_parent.style.height = h + 'px';
  }

  window.addEventListener('load', function() {
    const win_parent = window.parent;        

    if (!win_parent || window == win_parent) {
      return;
    }

    // 親のiframeのサイズ調整
    if (contact_type === 'info') {
      changeParentiFrameHeight(win_parent.document.getElementById('parentframe'));
    } else if (contact_type === 'recruit') {
      changeParentiFrameHeight(win_parent.document.getElementById('parentframe02'));
    }

    // 一度送信ボタンを押した後のみ親ウインドウのスクロールを実行する
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (params.get('p') === 'send') {
      const contact = win_parent.$('#contact');
      if (contact && contact.length > 0) {
        win_parent.$('body,html').stop().animate({scrollTop: contact.offset().top}, 500);
      }
    }
  });
}

